import { useSelector } from "react-redux";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useICD10Codes = (search) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["icd10Codes", tenantVal, search],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/icd10codes/search/${search.replace(/\//g, '-')}`
      );
      return response.data;
    },
    enabled: !!tenantVal && !!search,
    placeholderData: keepPreviousData,
  });
};
